import React from 'react';
import { NavLink as NavLinkNative } from 'react-router-dom';

const NavLink: React.ForwardRefRenderFunction<any, any> = ({ className, ...rest }, ref) => {
  return (
    <NavLinkNative
      className={({ isActive, isPending }) =>
        isPending ? `${className} pending` : isActive ? `${className} active` : className
      }
      ref={ref}
      {...rest}
    />
  );
};

export default React.forwardRef(NavLink);
